import React, { useState, useRef } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router";
import ExpenseForm from "../ExpenseForm/ExpenseForm";

function Edit({ project_id, account, permission, project }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [expense, setExpense] = useState(location.state.expense || null);
  const submitRef = useRef<any>();

  return (
    <div className="newExpensePage">
      <Card>
        <Card.Header
          style={{
            backgroundColor: "#fff",
            color: "#1C2655",
            padding: "0px 16px",
          }}
        >
          <Row style={{ padding: "20px 0 0 20px", alignItems: "center" }}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={(e) =>
                  navigate(`/projects/${project_id}/project_expenses`, {
                    state: null,
                  })
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className="text24" sm={9}>
              Edit {expense.description}
            </Col>
            {permission !== "view" &&
              permission !== "create" &&
              project?.data?.attributes?.status === "building" && (
                <Col>
                  <Button
                    style={{ marginLeft: "60px" }}
                    className="squareGreenButton"
                    onClick={() =>
                      submitRef && submitRef.current
                        ? submitRef.current.saveExpense(false)
                        : null
                    }
                  >
                    Save
                  </Button>
                </Col>
              )}
          </Row>
        </Card.Header>
        <hr style={{ marginLeft: "30px", marginRight: "30px" }} />
        <Card.Body>
          <ExpenseForm
            expenseProp={expense}
            project_id={project_id}
            account={account}
            ref={submitRef}
            permission={permission}
            project={project}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default Edit;
